export default class ElementIdService {
    generateIdFromName(name) {
        let id = name.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g,"")
            .replace(/ /g, "-")
            .replace(/ä/g, "a")
            .replace(/ö/g, "o")
            .replace(/å/g, "a");

        return encodeURIComponent(id);
    }
}